<template>
  <div v-if="group && !group.ignored" class="rbu-item-summary-table-row">
    <div class="rbu-item-summary-table-row-column-1"></div>
    <div class="rbu-item-summary-table-row-column-2" style="align-self: center">
      Group {{ String.fromCharCode(65 + idx) }} {{ group.name }}
    </div>
    <div
      class="rbu-item-summary-table-row-column-value"
      style="align-self: center"
    >
      {{
        group.calculated_sub_total
          ? $parseCurrency(group.calculated_sub_total)
          : "$0.00"
      }}
    </div>
    <div class="rbu-item-summary-table-row-column-multiplier"></div>
    <div class="rbu-item-summary-table-row-column-formula">
      <div
        style="
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 0.5rem;
        "
      >
        <v-textarea
          outlined
          dense
          hide-details
          auto-grow
          rows="1"
          :value="formulaPrefix"
          @input="onFormulaUpdate($event, formulaSuffix)"
        ></v-textarea>
        <div class="rbu-item-summary-group-rate">
          Rate
          {{ group.sub_total ? `(${$parseCurrency(group.sub_total)})` : "" }}
        </div>
        <v-textarea
          outlined
          dense
          hide-details
          auto-grow
          rows="1"
          :value="formulaSuffix"
          @input="onFormulaUpdate(formulaPrefix, $event)"
        ></v-textarea>
      </div>
      <!-- <v-textarea
        outlined
        dense
        hide-details
        placeholder="Formula"
        auto-grow
        rows="1"
        clearable
        :value="group.group_formula"
        @input="onSummaryGroupUpdate(idx, { group_formula: $event })"
      ></v-textarea> -->
      <!-- @input="onGroupUpdate(idx, { group_formula: $event })" -->
    </div>
    <div
      class="rbu-item-summary-table-row-column-descriptions"
      style="align-self: center"
    >
      <v-textarea
        outlined
        auto-grow
        rows="1"
        dense
        hide-details
        placeholder="Description"
        :value="group.group_descriptions"
        @input="onUpdate({ group_descriptions: $event })"
      ></v-textarea>
    </div>
    <div class="rbu-item-summary-table-row-column-actions"></div>
  </div>
  <div v-else></div>
</template>
<script>
import { ref, watch, inject, computed } from "@vue/composition-api";
import { RBU_MODULE_TENDER_RATE_MODE } from "@/constants";
import floatingPointFix from "js-floating-point";

export default {
  name: "RbuItemSummaryRow",
  components: {},
  props: {
    group: Object,
    idx: Number,
  },
  setup(props, { emit }) {
    const formulaPrefix = computed(() => {
      const components = (props.group.group_formula || "").split("{{value}}");

      if (components.length === 2) {
        return components[0];
      }
      return "";
    });
    const formulaSuffix = computed(() => {
      const components = (props.group.group_formula || "").split("{{value}}");

      if (components.length === 2) {
        return components[1];
      }
      return "";
    });
    const onFormulaUpdate = function (prefix, suffix) {
      onUpdate({ group_formula: `${prefix}{{value}}${suffix}` });
    };
    const onUpdate = _.debounce(function (evt) {
      console.debug("Item Summary Group Row Update: ", evt);
      let updates = {
        ...props.group,
        ...evt,
      };

      //   if (updates.previous_datapoint && updates.current_datapoint) {
      //     let sub_total =
      //       parseFloat(updates.current_datapoint.value) /
      //       parseFloat(updates.previous_datapoint.value);

      //     sub_total = floatingPointFix(sub_total);
      //     sub_total = Math.round(sub_total * 10000) / 10000;
      //     if (updates.formula) {
      //       try {
      //         sub_total = floatingPointFix(
      //           eval(updates.formula.replace("{{VALUE}}", sub_total))
      //         );
      //       } catch (e) {
      //         console.debug(e);
      //       }
      //     }
      //     sub_total = Math.round(sub_total * 10000) / 10000;
      //     updates.sub_total = sub_total;
      //   }

      emit("update", updates);
    }, 500);

    return {
      onUpdate,
      formulaPrefix,
      formulaSuffix,
      onFormulaUpdate,
    };
  },
};
</script>
<style>
.rbu-item-summary-group-rate {
  background-color: rgba(167, 18, 23, 1);
  color: white;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.15px;
  text-align: left;

  padding: 4px;
  gap: 10px;
  border-radius: 8px;
}
</style>
